import Vue from 'vue'
import ToastRackComponent from '../../fabric/toast-rack.vue'

export const props = {
  position: {
    type: String,
    default: 'top-left'
  },
  name: {
    type: String,
    default: 'toaster'
  },
}

export const ToastRack = /* #__PURE__ */ Vue.extend({
  name: 'ToastRack',
  mixins: [],
  props,
  render(h) {
    const { position } = this
    const $toaster = h(ToastRackComponent, {
      staticClass: 'toaster', 
      props: {
        position,
      },
    })
    return $toaster
  }
})
